import './App.css';
import { Row } from 'react-materialize'
import { Route, Routes } from "react-router-dom";
import Layout from "./components/Layout";
import Home2 from "./components/Home2";
import Music from "./components/Music";
import Video from "./components/Video";



function App() {
  return (
    <Row className="App">
      <header>
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route index element={<Home2 />} />
            <Route path="/music" element={<Music />} />
            <Route path="/videography" element={<Video />} />
          </Route>
        </Routes>
      </header>
    </Row>
  );
}

export default App;
